import React from 'react';

export default () => (
  <section className='container-fluid pt-0' id='listcomplish'>
          <div className='linebg'>
            <img
                src="./img/linebg.png"
                className="img-fluid"
                alt="Imageteam"
              />
          </div>
          <div className='row m-2-hor'>
            <div className='col-12 mb-5'>
              <div className='heading'>An Accomplish</div>
            </div>
            <div className='col-12'>
              <div className='listcomplish'>
                <span className='year'>2020</span>
                <span className='content'>Citrus Mood L-Shaped Modular Kitchen</span>
                <span className='detail'>Luxury Modern Home</span>
              </div>
              <div className='listcomplish'>
                <span className='year'>2020</span>
                <span className='content'>Nature Bliss Straight Modular Kitchen</span>
                <span className='detail'>Kitchen Home</span>
              </div>
              <div className='listcomplish'>
                <span className='year'>2019</span>
                <span className='content'>Woody Mist Straight Wardrobe Designs</span>
                <span className='detail'>Wardrobe Designs</span>
              </div>
              <div className='listcomplish'>
                <span className='year'>2019</span>
                <span className='content'>Contemporary Entertainment Wall Units</span>
                <span className='detail'>Entertainment</span>
              </div>
              <div className='listcomplish'>
                <span className='year'>2018</span>
                <span className='content'>Space Saving Furniture Palermo</span>
                <span className='detail'>Modern Furniture</span>
              </div>
              <div className='listcomplish'>
                <span className='year'>2018</span>
                <span className='content'>Eclectic Theme Interiors For Living Room</span>
                <span className='detail'>Modern Interiors</span>
              </div>
              <div className='listcomplish'>
                <span className='year'>2018</span>
                <span className='content'>Pop Theme Home Interiors</span>
                <span className='detail'>Home Interiors</span>
              </div>
              <div className='listcomplish'>
                <span className='year'>2017</span>
                <span className='content'>Kid Friendly Theme Home Interiors</span>
                <span className='detail'>Kid Modern Interiors</span>
              </div>
            </div>
          </div>
        </section>
);
